import $ from 'jquery';
import AjaxRequest from "../modules/ajax-request";

var AccountCourses = function (element) {
    this._div = element;
    var _url = $(this._div).data('url');

    $(this._div).removeAttr('data-url');

    var _this = this._div;
    var _ajaxRequest = new AjaxRequest({
        successCallback: function (response) {
            $(_this).append(response);
        }
    });
    _ajaxRequest.makeCall(_url);

    $(this._div).on('click', '[data-id="ajax_paginator"]', function () {
        var _span = $(this).find('[data-id="span"]');
        var _url = $(_span).data("href");
        var _this = this;

        var _ajaxRequest = new AjaxRequest({
            successCallback: function (response) {
                $(_this).removeClass("loading");
                $(_this).replaceWith(response);
            }
        });

        $(_this).addClass("loading");
        _ajaxRequest.makeCall(_url);
    });
};

export default AccountCourses;